import router from '../../router';
import * as Sentry from './../../tools/sentry';

function isJson (str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export default {
  namespaced: true,
  state: {
    token: (localStorage.getItem('auth') && isJson(localStorage.getItem('auth'))) ? JSON.parse(localStorage.getItem('auth')).token : false,
    name: (localStorage.getItem('auth') && isJson(localStorage.getItem('auth')) && JSON.parse(localStorage.getItem('auth')).error === undefined) ? JSON.parse(localStorage.getItem('auth')).user.name : false,
    id: (localStorage.getItem('auth') && isJson(localStorage.getItem('auth')) && JSON.parse(localStorage.getItem('auth')).error === undefined) ? JSON.parse(localStorage.getItem('auth')).user.id : false
  },

  getters: {
    isAuthenticated: state => state.token !== false
  },

  mutations: {
    USER_LOGOUT: (state) => {
      state.token = false;
      state.id = '';
      state.name = '';
      localStorage.removeItem('auth');
      Sentry.deleteUser();
    },
    USER_LOGIN: (state, {token, user}) => {
      state.token = token;
      state.id = user.id;
      state.name = user.name;
      localStorage.setItem('auth', JSON.stringify({token: token, user: user}));
      Sentry.setUser(user);
    },
    USER_SETTOKEN: (state, token) => {
      state.token = token;
      // Sentry.addBreadcrumb({
      //   category: 'auth',
      //   message: 'Setting Token',
      //   level: 'info',
      //   token:token,
      //   user: state.name
      // });

      localStorage.setItem('auth', JSON.stringify({token: token, user: {id: state.id, name: state.name}}));
    }
  },

  actions: {
    USER_LOGOUT: (context) => {
      context.commit('USER_LOGOUT');
      router.push('/login');
    },
    USER_LOGIN: (context, {token, user}) => {
      context.commit('USER_LOGIN', {token, user});
      router.push('/');
    }
  }

};



// WEBPACK FOOTER //
// ./src/store/modules/user.js